<template>
  <crud-modal
    :title="$t('modals.company.updateSlugTitle')"
    action="update"
    :on-submit="submit"
    :on-close="() => $emit('close')"
  >
    <div class="mb-6">
      {{ $t('modals.company.updateSlugTextPrefix') }}
      <span class="font-semibold">"{{ companyName }}"</span> {{ $t('modals.company.updateSlugTextSuffix') }} <br>
      {{ $t('modals.company.updateSlugWarning') }}
    </div>
    <form action="#">
      <label class="block mb-6 normal-case">
        <input-text-validated
          v-model="newSlug"
          :label="$t('modals.company.newSlug')"
          type="text"
          rules="required"
          input-class="w-full"
          class="w-full"
        /></label>
    </form>
  </crud-modal>
</template>

<script>
import CrudModal from '@/components/modals/crud-modal'
import UPDATE_COMPANY_SLUG from '@/graphql/UpdateCompanySlug.gql'
import InputTextValidated from '@/components/form/text-validated'

export default {
  components: { CrudModal, InputTextValidated },
  props: {
    companyId: {
      type: String,
      required: true
    },
    companyName: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      newSlug: ''
    }
  },
  methods: {
    async submit () {
      await this.$apollo.mutate({
        mutation: UPDATE_COMPANY_SLUG,
        variables: {
          input: {
            companyId: this.companyId,
            newSlug: this.newSlug
          }
        }
      })
      this.$router.go(0)
    }
  }
}
</script>
